export default {
  footer: {
    usefulLinks: 'Top Kurse und Erlebnisse in Deiner Nähe',
  },
}
